import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Navbar from "./components/Navbar";
import HomePage from "./components/HomePage";
import Dashboard from "./components/Dashboard";
import ApartmentManager from "./components/ApartmentManager";
import TenantManager from "./components/TenantManager";
import PaymentManager from "./components/PaymentManager";
import PaymentList from "./components/PaymentList";
import Login from "./components/Login";
import ProtectedRoute from "./components/ProtectedRoute";

export default function App() {
    const token = localStorage.getItem("access_token");

    return (
        <Router>
            <div
                style={{
                    minHeight: "100vh",
                    display: "flex",
                    flexDirection: "column",
                }}
            >
                <Navbar />

                <main
                    style={{
                        padding: "20px",
                        flex: 1,
                    }}
                >
                    <Routes>
                        <Route
                            path="/login"
                            element={
                                token ? (
                                    <Navigate to="/dashboard" replace />
                                ) : (
                                    <Login />
                                )
                            }
                        />

                        <Route
                            path="/"
                            element={
                                <ProtectedRoute>
                                    <HomePage />
                                </ProtectedRoute>
                            }
                        />

                        <Route
                            path="/dashboard"
                            element={
                                <ProtectedRoute>
                                    <Dashboard />
                                </ProtectedRoute>
                            }
                        />

                        <Route
                            path="/apartments"
                            element={
                                <ProtectedRoute>
                                    <ApartmentManager />
                                </ProtectedRoute>
                            }
                        />

                        <Route
                            path="/tenants"
                            element={
                                <ProtectedRoute>
                                    <TenantManager />
                                </ProtectedRoute>
                            }
                        />

                        <Route
                            path="/payment-manager"
                            element={
                                <ProtectedRoute>
                                    <PaymentManager />
                                </ProtectedRoute>
                            }
                        />

                        <Route
                            path="/payment-list"
                            element={
                                <ProtectedRoute>
                                    <PaymentList />
                                </ProtectedRoute>
                            }
                        />

                        <Route
                            path="*"
                            element={
                                <Navigate
                                    to={token ? "/dashboard" : "/login"}
                                    replace
                                />
                            }
                        />
                    </Routes>
                </main>

                <footer
                    style={{
                        textAlign: "center",
                        padding: "18px 10px",
                        fontSize: "12px",
                        color: "#888",
                        borderTop: "1px solid #eee",
                        backgroundColor: "#fff",
                    }}
                >
                    © {new Date().getFullYear()} Rental Manager — V.P. All rights reserved.
                </footer>
            </div>
        </Router>
    );
}
